<template>

  <div class="app-container">

    <el-card class="mb20 mt20 ml20 mr20 ta-l" v-show="showSearch" ref="searchBox">
      <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
        <el-form-item label="订单编号" prop="tradeNo">
          <el-input
              v-model="queryParams.tradeNo"
              placeholder="请输入订单编号"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="信用代码" prop="businessCode">
          <el-input
              v-model="queryParams.businessCode"
              placeholder="请输入刻企信用代码"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="刻企名称" prop="makeBusinessName" v-if="orgCode === '91210204341167191F'">
          <el-input
              v-model="queryParams.makeBusinessName"
              placeholder="请输入刻企名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="企业名称" prop="businessName">
          <el-input
              v-model="queryParams.businessName"
              placeholder="请输入企业名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="商品名称" prop="productName">
          <el-input
              v-model="queryParams.productName"
              placeholder="请输入商品名称"
              clearable
              style="width: 240px"
              @keyup.enter.native="handleQuery"
          />
        </el-form-item>
        <el-form-item label="订单来源" prop="sealName" v-if="orgCode === '91210204341167191F'">
          <el-select v-model="queryParams.isKq" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in isKqData"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付状态" prop="payStatus" v-if="orgCode === '91210204341167191F'">
          <el-select v-model="queryParams.payStatus" style="width: 240px" clearable placeholder="请选择">
            <el-option
                v-for="item in payStatusOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item label="" prop="" v-if="orgCode === '91210204341167191F'">-->
        <!--          <el-checkbox v-model="queryParams.isKq" :true-label="true" :false-label="null">刻企</el-checkbox>-->
        <!--        </el-form-item>-->
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="mb20 mt20 ml20 mr20 ta-l">
      <div>
        <div class="button-box flex-center-end" ref="buttonBox">
          <right-toolbar :showSearch.sync="showSearch" @queryTable="handleQuery"
                         storageKey="xxxxxxxx" @getColumns="getColumns"></right-toolbar>
        </div>
        <el-table
            v-loading="loading"
            :data="tableData"
            @expand-change="load"
            style="width: 100%"
            :height="getDynamicStyles(showSearch)">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="margin: 10px 50px">
                <el-table :data="scope.row.children">
                  <el-table-column
                      prop="sealCode"
                      label="印章编码"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="sealName"
                      min-width="250"
                      label="印章名称">
                  </el-table-column>
                  <el-table-column
                      prop="sealType"
                      label="印章类型"
                      align="center"
                      width="120">
                    <template slot-scope="scope">
                      <el-tag size="small" v-for="(item,index) in sealData" :key="index"
                              v-if="item.code == scope.row.sealType">{{ item.name }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="sealStatus"
                      label="状态"
                      align="center"
                      width="120">
                    <template slot-scope="scope">
                      <el-tag type="warning" v-if="scope.row.sealStatus == 0" size="small">待制作</el-tag>
                      <el-tag type="danger" v-if="scope.row.sealStatus == 9" size="small">注销</el-tag>
                      <el-tag type="success" v-if="scope.row.sealStatus == 1" size="small">正常</el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column
                      prop="sealValidBegin"
                      label="印章有效起始时间"
                      align="center"
                      width="180">
                  </el-table-column>
                  <el-table-column
                      prop="sealValidEnd"
                      label="印章有效截止时间"
                      align="center"
                      width="180">
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="tradeNo"
              label="订单编号"
              width="180">
          </el-table-column>
          <el-table-column
              prop="businessName"
              label="企业名称">
          </el-table-column>
          <el-table-column
              prop="productName"
              label="商品名称"
              align="center">
            <!--            <template slot-scope="scope">-->
            <!--              <el-tag size="small" >{{ scope.row.productName }}</el-tag>-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column
              prop="productPrice"
              label="价格"
              align="center"
              width="90">
          </el-table-column>
          <el-table-column
              v-if="orgCode === '91210204341167191F'"
              prop="makeBusinessName"
              label="刻企名称">
          </el-table-column>
          <!--          <el-table-column-->
          <!--              prop="makeType"-->
          <!--              label="印章制作类型"-->
          <!--              align="center"-->
          <!--              min-width="120">-->
          <!--            <template slot-scope="scope">-->
          <!--              <el-tag size="small" v-if="scope.row.makeType == 'cloud'">云章</el-tag>-->
          <!--              <el-tag size="small" v-if="scope.row.makeType == 'ukey'">ukey章</el-tag>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
              prop="status"
              label="状态"
              align="center">
            <template slot-scope="scope">
              <el-tag type="danger" v-if="scope.row.status == 0" size="small">未处理</el-tag>
              <el-tag type="success" v-if="scope.row.status == 1" size="small">已处理</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              prop="payType"
              label="支付方式"
              align="center">
            <template slot-scope="scope">
              <el-tag type="info" v-if="scope.row.payType == 'alipay'" size="small">支付宝支付</el-tag>
              <el-tag type="info" v-if="scope.row.payType == 'wxpay'" size="small">微信支付</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              v-if="orgCode === '91210204341167191F'"
              prop="payStatus"
              label="支付状态"
              align="center">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.payStatus == '1'" size="small">已付款</el-tag>
              <el-tag type="danger" v-if="scope.row.payStatus == '0'" size="small">未付款</el-tag>
              <el-tag v-if="scope.row.payStatus == '9'" size="small">已退款</el-tag>
            </template>
          </el-table-column>
          <el-table-column
              v-if="orgCode === '91210204341167191F'"
              prop="createTime"
              label="订单创建时间"
              align="center">
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
              width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="handleDelivery(scope.row)"
                         v-if="orgCode === '91210204341167191F' && scope.row.makeType == 'ukey' && scope.row.payStatus == '1' && !scope.row.deliverNo">
                发货
              </el-button>

              <el-button size="mini" type="text" @click="handleCheck(scope.row)">查看</el-button>

              <el-popconfirm
                  class="ml10"
                  @confirm="handleRefund(scope.row)"
                  v-if="scope.row.payStatus == 1 && orgCode === '91210204341167191F'"
                  :title="'是否确认退款 ：' + scope.row.productName + '?'"
              >
                <el-button size="mini" type="text" slot="reference">退款</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>


        <div class="pagination-container" ref="pagination">
          <pagination
              :total="total"
              :page.sync="queryParams.pageNum"
              :limit.sync="queryParams.pageSize"
              @pagination="getTradeInfoList"

          />
        </div>

        <shipping-details ref="details" @handleQuery="getTradeInfoList"/>

        <delivery ref="delivery" @handleQuery="getTradeInfoList"/>
      </div>
    </el-card>

  </div>

</template>

<script>
import Cookie from "js-cookie";
import {enumDevice} from '@/utils/Ukey'
import ShippingDetails from "@/pages/customerEnterprise/components/shippingDetails.vue";
import Delivery from "@/pages/customerEnterprise/components/delivery.vue";
import {getDynamicStyles} from "@/utils/ruoyi";

export default {
  name: "orderList",
  components: {Delivery, ShippingDetails},
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      // 总条数
      total: 0,
      tableKey: 0,

      showSearch: true,

      tableData: [],

      sealData: [],

      statusOption: [
        {
          value: '0',
          label: '待制作'
        },
        {
          value: '1',
          label: '正常'
        },
        {
          value: '9',
          label: '注销'
        },
      ],

      payStatusOption: [
        {
          value: '0',
          label: '未付款'
        },
        {
          value: '1',
          label: '已付款'
        },
        {
          value: '9',
          label: '已退款'
        },
      ],

      makeTypeOption: [
        {
          value: 'ukey',
          label: 'k章'
        },
        {
          value: 'cloud',
          label: '云章'
        },
      ],

      isKqData: [
        {
          value: 'true',
          label: '客企'
        },
        {
          value: 'false',
          label: '印章平台'
        },
      ],

      userInfo: {},
      orgCode: ''
    }
  },
  created() {
    this.orgCode = Cookie.get('orgCode')
    this.getSealType()
    this.handleQuery()
  },
  methods: {
    getDynamicStyles,
    getColumns(e) {
      this.tableKey += 1
      this.$set(this, 'columns', e)
    },
    handleRefund(e) {
      this.loading = true
      this.$http.post(this.$api.customerEnterprise.refund, {tradeNo: e.tradeNo}).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("退款成功");
          this.getTradeInfoList()
        } else {
          this.$message.error(res.data.msg)
          this.loading = false
        }
      })
    },
    load(value) {
      this.$http.post(this.$api.customerEnterprise.getTradeInfo, {tradeNo: value.tradeNo}).then((res) => {
        if (res.data.code == 200) {
          this.$set(this.tableData[value.index], 'children', res.data.data)
        }
      })
    },
    handleDelivery(e) {
      this.$refs.delivery.show(true, e.tradeNo);
    },
    handleCheck(e) {
      this.$refs.details.show(true, e.tradeNo, e.deliverNo);
    },
    getUkey(e) {
      console.log(e)
      let ukey = enumDevice()
      if (!ukey) {
        this.$message.error('未找到ukey')
      } else {
        this.$http.post(this.$api.customerEnterprise.doMakeESealNow, {id: e.id, uid: ukey}).then(res => {
          if (res.data.code == 200) {
            this.$message.success("绑定成功");
            this.getTradeInfoList()
          }
        })
      }
    },
    getSealType() {
      this.$http.post(this.$api.user.getSealType, {type: "business"}, {"Content-Type": "application/x-www-form-urlencoded"}).then(res => {
        if (res.data.code == 200) {
          this.sealData = res.data.data || []
        }
      })
    },
    getTradeInfoList() {
      this.loading = true
      this.$http.get(this.$api.user.onlineTradeInfo, this.queryParams).then((res) => {
        if (res.data.code == 200) {
          let tableData = res.data.rows
          tableData.forEach((e, index) => {
            e.children = []
            e.index = index
          })
          this.tableData = tableData
          this.total = res.data.total
          this.loading = false;
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getTradeInfoList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        isKq: null
      },
          this.handleQuery();
    },
  }
}
</script>

<style scoped lang="less">

</style>
